import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a6697c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "flex-grow-1" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "d-flex align-items-center mb-2" }
const _hoisted_8 = { class: "text-gray-800 fs-2 fw-bolder me-1" }
const _hoisted_9 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-grow-1 pe-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-wrap" })
], -1))
const _hoisted_11 = { class: "d-flex align-items-center w-200px w-sm-300px flex-column mt-3" }
const _hoisted_12 = { class: "row g-5 g-xl-8" }
const _hoisted_13 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_FactorValuesTable = _resolveComponent("FactorValuesTable")!
  const _component_FactorValuesEditing = _resolveComponent("FactorValuesEditing")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Tabs, {
      tableUrl: "/manage/ire/factors-bathrooms-listing",
      areaValueUrl: "/manage/ire/factors-bathrooms-values",
      tableTitle: "Factors Bathrooms List",
      areaValueTitle: "Factors Bathrooms Values"
    }),
    (_ctx.can('read', 'instant-rent-estimator'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.translate('ValueFactorBathroomPanel')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.selectedArea,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedArea) = $event)),
                      searchable: true,
                      required: true,
                      canDeselect: false,
                      options: _ctx.areas,
                      label: "areaName",
                      trackBy: "areaName",
                      valueProp: "id",
                      noResultsText: _ctx.translate('noResultsFound'),
                      onChange: _ctx.handleAreaChange
                    }, null, 8, ["modelValue", "options", "noResultsText", "onChange"])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.factorsValues, (value, key) => {
          return (_openBlock(), _createBlock(_component_FactorValuesTable, {
            key: key,
            value: value,
            onShowEditModal: _ctx.showFactorEditModal
          }, null, 8, ["value", "onShowEditModal"]))
        }), 128))
      ])
    ]),
    _createVNode(_component_FactorValuesEditing, {
      "edit-data": _ctx.editData,
      onNewValueCreated: _ctx.refreshValues,
      selectedAreaId: _ctx.selectedArea
    }, null, 8, ["edit-data", "onNewValueCreated", "selectedAreaId"])
  ], 64))
}